import {HeaderUICache} from "./headerUICache";
import DomHelper from "../../utils/DomHelper";


var _HeaderUICache = HeaderUICache;

export const apiMethods = {
    setParameters: setParametersOnDomReady,
    title(newTitle = null) {
        if (_isParamMissing(newTitle)) return false;
        setTitle(newTitle);
    },
    pageTitle(newPageTitle = null){
        if (_isParamMissing(newPageTitle)) return false;
        setPageTitle(newPageTitle);
    }
};

function setParametersOnDomReady(params) {
    if (DomHelper.isReady()) {
        setParameters(params);
    } else {
        DomHelper.execMethodsOnReady([
            () => setParameters(params)
        ]);
    }
}

function setParameters({title, pageTitle} = {}) {
    execMethodIfParamDefined(pageTitle,apiMethods.pageTitle);
    execMethodIfParamDefined(title, apiMethods.title);
}

function execMethodIfParamDefined(param, method) {
    if (param !== undefined) {
        method(param);
    }
}

function setTitle(newTitle) {
    let {title, titleDesktop} = _HeaderUICache;
    _setTextContent(title, newTitle);
    _setTextContent(titleDesktop, newTitle);
}

function setPageTitle(newPageTitle){
   document.title = newPageTitle
}

function _setTextContent(element, text) {
    if (element != null && typeof(element) != "undefined") {
        element.textContent = text;
    }else{
        console.log("unable to find element");
    }
}

function _isParamMissing(param) {
    return param === null;
}



// WEBPACK FOOTER //
// ./src/js/api/header/headerMethods.js